const constantsTranslation = {
  'const.order.ratings.horrible': 'Too Bad',
  'const.order.ratings.bad': 'Bad',
  'const.order.ratings.normal': 'Normal',
  'const.order.ratings.good': 'Good',
  'const.order.ratings.amazing': 'Amazing',
};

export default constantsTranslation;
